// Brave's thumbnails go through our server, so a refused picture (402) never shows
// as a console error; the server sends an empty 1x1 image and the card hides it.
export const thumbSrc = (url) => {
  if (!url) return null;
  return /^https:\/\/imgs\.search\.brave\.com\//i.test(url) ? `/api/thumb?u=${encodeURIComponent(url)}` : url;
};

export const isEmptyThumb = (img) => !!img && img.naturalWidth <= 1;

// A guest with no GPS has no weather card, and nothing to ask the server (no 400 in
// the console). Signed in, the server knows the person's place.
export const canAskWeather = (coords, user) => !!(coords || user);
